import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cartSlice";
import storeReducer from "./storeSlice";
import authReducer from "./authSlice";
import orderOptionReducer from "./orderOptionSlice";

import { local } from "../embed/storage";
export const store = configureStore({
  reducer: {
    cart: cartReducer,
    store: storeReducer,
    auth: authReducer,
    orderOption: orderOptionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Persist cart-related things to localStorage
store.subscribe(() => {
  const state = store.getState();
  const { cart, store: storeState } = state;

  try {
    local.setItem("cart_id", cart.cartId);
    local.setItem("cart_menu_id", cart.menuId);
    local.setItem("cart", JSON.stringify(cart.items));
    local.setItem("cart_store_id", JSON.stringify(cart.cartStoreId));
    local.setItem("uusid", JSON.stringify(cart.uusid));
    local.setItem("olo_utm", storeState.utm);
  } catch {
    // ignore
  }
});
